import React, {useMemo} from 'react';
import {SalesforceLead, SalesforceLeadField} from 'api';
import Checkbox from './Checkbox';
import Input from './Input';
import Date from './Date';
import Url from './Url';
import Number from './Number';
import Name from './Name';

interface Props {
  field: SalesforceLeadField;
  salesforceLead: SalesforceLead;
}

export const FieldValue: React.FC<Props> = ({field, salesforceLead}) => {
  const Value = useMemo(() => {
    const value = salesforceLead.addition[`${field.fieldName}`];

    if (field.fieldType === 'checkbox') {
      return <Checkbox field={field} salesforceLead={salesforceLead} />;
    } else if (field.fieldType === 'address') {
      const hash = value;
      if (!hash) {
        return null;
      }
      const address = `${hash?.state}${hash?.city}${hash?.street}`;
      return <div>{address}</div>;
    } else if (
      ['text', 'phone'].includes(field.fieldType) &&
      field.updateable
    ) {
      return <Input field={field} salesforceLead={salesforceLead} />;
    } else if (field.fieldType === 'date' && field.fieldName.endsWith('__c')) {
      return <Date field={field} salesforceLead={salesforceLead} />;
    } else if (field.fieldType === 'url' && field.updateable) {
      return <Url field={field} salesforceLead={salesforceLead} />;
    } else if (
      ['currency', 'int'].includes(field.fieldType) &&
      field.updateable
    ) {
      return <Number field={field} salesforceLead={salesforceLead} />;
    } else if (field.fieldName === 'Name') {
      return <Name field={field} salesforceLead={salesforceLead} />;
    } else {
      return <div>{value}</div>;
    }
  }, [field, salesforceLead.addition]);

  return (
    <div className="flex px-4 align-middle text-foreground">
      <div className="w-2/5 text-sm ">{field.label}</div>
      <div className="w-3/5">{Value}</div>
    </div>
  );
};
